export default "https://cdn-static.gokick.com/assets/bae15fb1898ed89c0d72225e63ca082ea63e0d65/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";